<template>
    <Card class="approval" :bordered="false" :dis-hover="true" :padding="0" style="position: relative;">
        <!-- <div
            style="display: flex; flex-flow: row nowrap; justify-content: flex-end;align-items: center;position: absolute;top: -53px;right:0;z-index: 99">
           
           
        </div> -->
        <!-- <core-header> -->
        <anchorNavigation :show="showAnchorComputed" :data="anchorList" ref="anchorNavigation">
            <template v-if="!hideTitle">
                <Row  v-if="showApproval" style="height: 100px;" type="flex" align="middle" justify="space-between">
                    <Col span="18">
                    <div class="mainHeader">{{approvalTitle ? approvalTitle : processInfo.subject}}</div>

                    <div class="status">
                        <Tooltip :content="errorInfo" style="display: inline">
                            {{approvalStatus.fdStatus}}
                        </Tooltip>
                    </div>
                    <div class="operate-box">
                        <Button class="operate-btn" :key='index' v-for="(item, index) in BtnList" @click="handleBeforeClick(index)" :type="index === 0 ? 'primary' : 'ghost'"
                                :loading="loadingObj['loading' + index]"
                                size="default">{{item.name}}
                        </Button>
                        <template v-if="!this.approval">
                            <slot name="saveButton"></slot>
                        </template>
                        <slot name="delFlowBtn"></slot>
                        <!--返回-->
                        <Button type="ghost" @click="returnBtn" size="default"
                                style="margin-left: 10px">
                            {{this.$t('common.back') }}
                        </Button>
                        <div style='display:inline-block;'>
                            <Form :model="topForm" label-position="right" class="no-mb">
                                <FormItem :label="$t('approval.OperationRole')" :label-width="80" inline>       <!--操作角色-->
                                    <Select :placeholder="$t('importNoticeCommon.t4')" v-model="topForm.approveRole" @on-change="changeApproveRole"
                                            :disabled="!approveRoleList.length" size="default">
                                        <Option v-for="item in approveRoleList" :value="item.roleType" :key="item.fdTaskId">{{
                                            item.roleTypeName }}
                                        </Option>
                                    </Select>
                                </FormItem>
                            </Form>
                        </div>
                    </div>

                    </Col>
                    <Col span="6">
                    <div class="operate-info">
                        <p>{{$t('approval.t1')}}：{{this.draftInfo.fdHandlerId}}</p>
                        <p>{{this.draftInfo.department}}</p>
                        <!-- <p>流程IT/供应链系统/SRM</p> -->
                        <p>{{this.draftInfo.fdHandlerTime || ''}}</p>
                    </div>
                    </Col>
                </Row>
            </template>
            <div class="fixed-bottom" ref="scroll_wrapper">
                <slot></slot>
                <h3 v-if="showApproval" style="margin: 10px 0;font-weight: bold;font-size:14px;" id='approval_test'>{{$t('approval.ApprovalTitle')}}</h3><!--流程审批(流程节点、审批状态)-->
                <Tabs v-if="showApproval" v-model="childTabModal" :animated="false" @on-click="refreshIframe">
                    <TabPane :label="$t('approval.Approvalrecord1')" name="childTab1" style="min-height: 500px">         <!--流程节点-->

                        <Form :model="approvalForm" label-position="left" ref="approvalForm" :rules="ruleValidate">
                            <!--<div v-if="approval">-->
                            <!--<div class="subheading mb-10 mt-15">审批记录</div>-->
                            <!--<FormItem :label="item.nodeName" :label-width="80" v-if="manualNodes.length"-->
                            <!--v-for="(item, index) in manualNodes">-->
                            <!--<RadioGroup v-model="approvalForm['manualRadio_' + index]" size="default"-->
                            <!--@on-change="changeRaido"-->
                            <!--:key="approvalForm['manualRadio_' + index]">-->
                            <!--<Radio v-for="innerItem in item.branchNodeOptions" :label="innerItem.toNodeId"-->
                            <!--:disabled="true">{{innerItem.text}}-->
                            <!--</Radio>-->
                            <!--</RadioGroup>-->
                            <!--</FormItem>-->

                            <!--<div style="width: 100%;margin-bottom: 10px">-->
                            <!--<steps-bar title="" :current="currProcess" :barData="barData"></steps-bar>-->

                            <!--</div>-->

                            <!--<Table :data="block3.data" :columns="block3.columns" border stripe size="default"></Table>-->
                            <!--</div>-->


                            <!--<div v-else>-->
                            <div v-if="approvalStatus.fdStatusCode !== '10'"><!--非草稿状态-->
                                <div class="subheading mb-10 mt-15">{{$t('approval.Approvalrecord')}}</div>
                                <!--审批记录-->
                                <template v-if="manualNodes.length && approvalStatus.fdStatusCode !== '11'">
                                    <FormItem :label="item.nodeName" :label-width="120" v-for="(item, index) in manualNodes" :prop="'manualRadio_' + index" :key="index">
                                        <RadioGroup v-model="approvalForm['manualRadio_' + index]" size="default"
                                                    @on-change="changeRaido"
                                                    :key="approvalForm['manualRadio_' + index]">
                                            <Radio v-for="(innerItem) in item.branchNodeOptions" :key='innerItem.toNodeId' :label="innerItem.toNodeId"
                                                :disabled="true">{{innerItem.text}}
                                            </Radio>
                                        </RadioGroup>
                                    </FormItem>
                                </template>

                                <div style="width: 100%;margin-bottom: 10px">
                                    <steps-bar title="" :current="currProcess" :barData="barData"></steps-bar>

                                </div>

                                <Table :data="block3.data" :columns="block3.columns" border stripe size="default"></Table>
                            </div>

                            <div v-if="approvalStatus.fdStatusCode === '10' || approvalStatus.fdStatusCode === '11'"><!--草稿/驳回状态-->
                                <div class="set-flex">
                                    <div class="mb-10 mt-15 subheading">
                                        {{$t('approval.ApprovalProcess')}}       <!--审批流程-->
                                    </div>
                                    <Button type="primary" @click="getPrevProcessApprovers" class="m-btn-more-4"
                                            v-if="processCreatedBy === supplierInfo.loginName">
                                        {{$t('approval.LastApprover')}}
                                    </Button>     <!--取上次审批处理人-->
                                </div>
                                <template v-if="manualNodes.length">
                                    <FormItem :label="item.nodeName" :label-width="120" :required="true"
                                            v-for="(item, index) in manualNodes" :prop="'manualRadio_' + index" :key="index">
                                        <RadioGroup v-model="approvalForm['manualRadio_' + index]" size="default"
                                                    @on-change="changeRaido"
                                                    :key="approvalForm['manualRadio_' + index]">
                                            <Radio v-for="innerItem in item.branchNodeOptions" :label="innerItem.toNodeId" :key="innerItem.toNodeId"
                                                :disabled="radioDisabled">{{innerItem.text}}
                                            </Radio>
                                        </RadioGroup>
                                    </FormItem>
                                </template>
                                <Table :data="block2.data" :columns="block2.columns" :loading="radioDisabled" border stripe
                                       class="mt-20" v-show="showTbl"></Table>
                            </div>

                            <!--</div>-->
                        </Form>

                    </TabPane>
                    <TabPane :label="$t('approval.Flowchart')" name="childTab2">
                        <iframe name="myiframe" id="myiframe" ref="myiframe"
                                :src="iframeSrc" @load="iframeLoaded"
                                frameborder="0" align="left" width="100%" :height="iframeHeight" scrolling="no">
                            <p>{{$t('approval.tips1')}}</p>          <!--你的浏览器不支持iframe标签-->
                        </iframe>
                    </TabPane>
                </Tabs>
            </div>
        </anchorNavigation>
        <!-- </core-header> -->

        <Modal v-model="btnShowModal.show"
               :title="btnShowModal.modalTitle"
               :width="btnShowModal.modalWidth"
               :mask-closable="false"
               @on-ok="btnShowModal.onOk">
            <Form :model="btnModalForm" label-position="left">
                <Row type="flex" align="top" justify="space-between">
                    <Col span="12">
                        <FormItem :label="$t('approval.Rejectto')" :label-width="60"
                                  v-if="btnShowModal.operationType === 'handler_refuse'">       <!--驳回到-->
                            <Select :placeholder="$t('importNoticeCommon.t4')" v-model="btnModalForm.rejectTo" @on-change="changeApproveRole">
                                <Option v-for="item in rejectList" :value="item.nodeId" :key="item.nodeId">{{
                                    item.nodeName }}
                                </Option>
                            </Select>
                        </FormItem>
                        <FormItem :label="$t('approval.Handler')" :label-width="60"
                                  v-if="btnShowModal.operationType === 'handler_commission' || btnShowModal.operationType === 'handler_communicate' || btnShowModal.operationType === 'handler_abandon' || btnShowModal.operationType === 'circulate'">
                            <!--处理人-->
                            <!--<Tag v-for="item in btnModalForm.handlePersonList" :key="item.user" :name="item.userName"-->
                            <!--closable @on-close="handleClosePerson" color="blue">{{ item.userName }}-->
                            <!--</Tag>-->
                            <!--<Button icon="ios-plus-empty" type="dashed" size="default" @click="handleAddPerson">添加-->
                            <!--</Button>-->
                            <!--<staff-selector v-model="staffSelector.ssValue"-->
                            <!--:windowDragable="staffSelector.windowDragable"-->
                            <!--:cLang="staffSelector.cLang" :noFastBar="staffSelector.noFastBar"-->
                            <!--:banEdit="staffSelector.banEdit" :canDrag="staffSelector.canDrag"-->
                            <!--:onlyFsearch="staffSelector.onlyFsearch" :loginId="staffSelector.loginId"-->
                            <!--:readOnly="staffSelector.readOnly"-->
                            <!--:buttonStyle="buttonStyle" :buttonText="buttonText"-->
                            <!--:udType="staffSelector.udType" :single="staffSelector.single"-->
                            <!--@change="staffSelector.change" @fsblur="staffSelector.fsblur">-->
                            <!--</staff-selector>-->
                            <vue-midea-selector :source="mideaSelector.source" :dataType="mideaSelector.dataType"
                                                :env="mideaSelector.env"
                                                :disabled="mideaSelector.disabled" :lang="mideaSelector.lang"
                                                :configurations="mideaSelector.configurations"
                                                :bandellist="mideaSelector.bandellist"
                                                :expendAccountName="expendAccountName"
                                                @callback="mideaSelector.callback">
                            </vue-midea-selector>
                        </FormItem>
                    </Col>
                    <Col span="12" style="text-align: right;">
                        <FormItem label="" v-if="btnShowModal.operationType === 'handler_refuse'">
                            <Checkbox v-model="btnModalForm.returnCurr">{{$t('approval.tips2')}}</Checkbox>
                            <!--重新提交后直接返回本节点-->
                        </FormItem>
                    </Col>
                </Row>

                <FormItem :label="$t('approval.DisposalOpinion')">         <!--处理意见-->
                    <Input v-model="btnModalForm.auditNote" type="textarea" placeholder=""></Input>
                </FormItem>
                <div class="mb-10 mt-15" v-if="btnShowModal.operationType !== 'circulate'">
                    <!--<div class="mb-10 mt-15">-->
                    <Upload action="/srmpos/common/uploadFile" :show-upload-list="false" :max-size="1048576"
                            :format="['xls','xlsx','doc','docx','jpeg','jpg','png','gif','pdf','txt','xml','dmg','pptx','zip','rar','xlsb','eml']"
                            :before-upload="beforeUpload"
                            :on-progress="uploadProgress" :on-success="uploadSuccess2" style="display: inline">
                        <Button type="primary" size="default" class="mb-10" :loading="uploadLoading">
                            {{$t('approval.UploadAttachments')}}
                        </Button>      <!--上传附件-->
                    </Upload>
                    <span
                        style="padding-left: 10px;;font-size: 12px;color: #9ea7b4;">{{$t('approval.tips3')}}</span>
                    <!--50MB以内，最多上传10个-->
                </div>
                <div v-for="(item, index) in btnShowModal.FileList" :key="index">
                    <a :href="'/srmpos/common/downloadFile?docId=' + item.fileId"
                       style="color:#5cadff; font-size: 13px;">{{item.fileName}}</a>
                    <Button type="text" icon="close" :disabled="false" style="padding: 5px 10px;"
                            @click="btnShowModal.deleteFile(index)"></Button>
                </div>
            </Form>
        </Modal>

        <Modal v-model="personModal.show"
               :title="personModal.modalTitle"
               :width="personModal.modalWidth"
               @on-ok="personModal.onOk">

            <Row type="flex" align="top" justify="center">
                <Col span="12">
                    <Input v-model="personModal.searchIpt" type="text" icon="search" size="default"
                           :placeholder="$t('approval.tips4')"
                           @on-click="clickInput" @keydown.native.enter="clickInput"></Input>           <!--请输入搜索人员-->
                    <Table :data="personModal.data" :columns="personModal.columns" :loading="personModal.loading"
                           :show-header="false" stripe height="350" @on-selection-change="onSelectionChange"
                           ref="searchPerTable"></Table>
                    <m-pagination :showElevator="personModal.settings.showElevator"
                                  :showSizer="personModal.settings.showSizer"
                                  :currentPage="personModal.settings.currentPage"
                                  :pageSize="personModal.settings.pageSize" :total="personModal.settings.total"
                                  :pageSizeOpts="personModal.settings.pageSizeOpts"
                                  @on-page-size-change="onPageSizeChangeModal"
                                  @on-current-page-change="onCurrentPageChangeModal"></m-pagination>
                </Col>
                <Col span="4" style="text-align: center">
                    <Button style="margin: 150px 0 10px 0" @click="selectAll">{{$t('approval.AddAll')}}</Button>
                    <!--全部添加-->
                    <Button style="margin: 10px 0" @click="delAll">{{$t('approval.DeleteAll')}}</Button>
                    <!--全部删除-->
                </Col>
                <Col span="8">
                    <div style="height: 24px;">{{$t('approval.Selected')}}<span
                        style="padding-left: 10px;color: #1c2438">{{personModal.data2.length}}</span>          <!--已选-->
                    </div>
                    <Table :data="personModal.data2" :columns="personModal.columns2"
                           :show-header="false" stripe height="350"></Table>
                </Col>
            </Row>
        </Modal>
        <div style="position:fixed;right:67px;bottom:200px;cursor:pointer;z-index:9999;color:#1890ff;" v-if="backTop" @click="backToTop"><Tooltip content='返回顶部'><i style="font-size:26px;margin-left:6px;" class="el-icon-mf mf-chevron-circle-up" ></i></Tooltip></div>

    </Card>
</template>

<script>
import axios from 'axios';
import mPagination from '@/components/awesome/page/pagination';
import { formatDateTime } from '@/utils/datetime-format';
import stepsBar from '@/components/awesome/stepsbar';
import anchorNavigation from '@/components/anchorNavigation';
// import loadVueComponents from '../../../../utils/loadVueComponents.js'

    export default {
        components: {mPagination, stepsBar, anchorNavigation},
        props: {
            hideTitle: {
                type: Boolean,
                default: false
            },
            showApproval: {
                type: Boolean,
                default: false
            },
            showAnchor: {},
            anchorList: {
                type: Array,
                default() {
                    return [
                        {
                            id: 'panel_1',
                            text: this.$t('approval.t1'),
                        },
                        {
                            id: 'approval_test',
                            text: this.$t('approval.t2'),
                        },
                    ];
                }
            },
            deelSubmit: {
                type: Boolean,
                default: false
            },
            autoChangeRole: {
                type: Boolean,
                default: false
            },
            approvalTitle: {
                type: String,
                default: ''
            },
            // supplierInfo: {
            //     type: Object,
            //     default() {
            //         return {};
            //     }
            // },
        },
        data() {
            return {
                backTop: false,
                draftInfo: {},
                expendAccountName: '',
                env: 'sit',
                loadingObj: {},
                lastData: [],
                barData: [],
                currNodes: [],      // 当前审批节点
                childTabModal: 'childTab1',
                iframeSrc: '',      //  流程图
                iframeHeight: null,
                nodeInstanceId: null,
                btnCurrIndex: null,     //  当前点击按钮下标
                chosenFrom: '',     //  人员选择框要赋值的地方
                currProcess: null,  //  当前流程节点
                processInfo: {
                    subject: null
                },
                FileList: [],
                chosenSelection: [],
                approvalForm: {
                    radio: ''
                    // manualRadio_0: '',
                    // manualRadio_1: '',
                },
                ruleValidate: {
                    // manualRadio_0: [
                    //     { required: true, message: '请选择', trigger: 'blur' }
                    // ]
                },
                topForm: {
                    approveRole: ''
                },
                block1: {
                    data: [],
                    columns: [
                        {
                            title: this.$t('approval.FileName'),            /* '文件名', */
                            key: 'fileName',
                            align: 'left',
                            // width: 110,
                            render: (h, params) => {
                                let tempBtn = '';
                                if (!(this.billState === 'SUBMITED' || this.billState === 'APPROVED')) {
                                    tempBtn = h('Button', {
                                        props: {
                                            type: 'text',
                                            icon: 'close',
                                            disabled: false
                                        },
                                        on: {
                                            click: () => {
                                                this.$Modal.confirm({
                                                    content: this.$t('approval.DeleteAttachment'),          /* '是否删除附件？', */
                                                    onOk: () => {
                                                        params.row.fileName = '';
                                                        params.row.fileId = '';
                                                        this.block1.data[params.index] = params.row;
                                                    }
                                                });
                                            }
                                        }
                                    });
                                }
                                return h('div', {}, [
                                    h('a', {
                                        attrs: {
                                            href: '/srmpos/common/downloadFile?docId=' + params.row.fileId
                                        }
                                    }, params.row.fileName),
                                    tempBtn
                                ]);
                            }
                        }
                        // {
                        //     title: '大小',
                        //     key: 'fileSize',
                        //     align: 'center',
                        //     width: 110,
                        // },
                    ]
                },
                block2: {
                    currTblIndex: null,
                    data: [],
                    columns: [
                        {
                            title: this.$t('common.sequence'),          /* '序号', */
                            key: 'vendorRange',
                            align: 'center',
                            width: 50,
                            type: 'index'
                        },
                        {
                            title: this.$t('approval.ApprovalNode'),            /* '审批节点', */
                            key: 'nodeId',
                            align: 'center',
                            width: 70
                        },
                        {
                            title: this.$t('approval.CirculationMode'),        /* '流转方式', */
                            key: 'processType',
                            align: 'center',
                            width: 110
                        },
                        {
                            title: this.$t('approval.NodeName'),            /* '节点名称', */
                            key: 'nodeName',
                            align: 'center',
                            width: 160
                        },
                        // {
                        //     title: this.$t('approval.Approver'),            /*'审批人',*/
                        //     key: 'handlerNames',
                        //     // align: 'center',
                        //     // width: 110,
                        //     render: (h, params) => {
                        //         let chosenBtn = '';
                        //         let mustChosen = '';
                        //         if (params.row.canSelected) {
                        //
                        //             let tempArr = [];
                        //             this.block2.data[params.index].tempApprovalList.map(item => {
                        //                 let canNotDelArr = params.row.notModifyHandlerIds ? params.row.notModifyHandlerIds : [];
                        //                 if (!canNotDelArr.includes(item.user)) {
                        //                     tempArr.push(item.user);
                        //                 }
                        //             });
                        //
                        //             chosenBtn = h('vue-midea-selector', {
                        //                 props: {
                        //                     // 是否开启弹窗可拖拉
                        //                     windowDragable: false,
                        //                     // 是否允许拖拽
                        //                     canDrag: true,
                        //                     // 取消快速搜索栏
                        //                     noFastBar: true,
                        //                     // 是否禁止编辑
                        //                     banEdit: false,
                        //                     // 是否单选
                        //                     single: false,
                        //                     // 是否只有快速选择
                        //                     onlyFsearch: false,
                        //                     // v-model是否回传loginId
                        //                     loginId: false,
                        //                     //只读模式（人名，人名，人名。。。）
                        //                     readOnly: false,
                        //                     //小图标+按钮风格 noFastBar 设为true 才能生效
                        //                     buttonStyle: false,
                        //                     // select type ： 人员和部门之间切换 1:只搜部门，2:只搜人，3:人和部门
                        //                     udType: 3,
                        //                     // 自定义快速搜索栏的搜索占位符
                        //                     fsPlaceholder: undefined,
                        //                     // 不能删除列表,以id为唯一标识
                        //                     banDelList: [],
                        //                     // 双向绑定值
                        //                     ssValue: [],
                        //                     // 当需要组件外更新人员时使用
                        //                     ssData: [],
                        //                     // 当前语言
                        //                     cLang: JSON.parse(window.localStorage.getItem('user')).fdLangType, //   this.$store.state.user.fdLangType,
                        //                     //按钮文字
                        //                     buttonText: '',
                        //                     // currentUser: {this.supplierInfo.loginName},
                        //                     // data: tempArr,
                        //                     // data: [],
                        //                     resources: {
                        //                         data: tempArr
                        //                     }
                        //                 },
                        //                 style: {
                        //                     borderLeft: '1px solid #c3cbd6',
                        //                     fontSize: '18px',
                        //                     paddingRight: '14px',
                        //                     paddingLeft: '12px',
                        //                 },
                        //                 on: {
                        //                     change: (val, val2) => {
                        //                         let tempObj = JSON.parse(JSON.stringify(this.block2.data[params.index]));
                        //                         let stuffs = val.map(innerItem => {
                        //                             return {
                        //                                 user: innerItem.departmentNumber ? innerItem.departmentNumber : innerItem.loginId,
                        //                                 userName: innerItem.name,
                        //                                 // departmentNumber: innerItem.departmentNumber,
                        //                                 type: innerItem.departmentNumber ? 'DEPARTMENT' : 'USER',
                        //                             };
                        //                         });
                        //                         let tempArr2 = [];  //JSON.parse(JSON.stringify(params.row.notModifyHandlerIds ? params.row.notModifyHandlerIds : []));
                        //                         tempObj.tempApprovalList = JSON.parse(JSON.stringify(stuffs));
                        //
                        //                         tempObj.tempApprovalList.map(item => {
                        //                             tempArr2.push(item.user);
                        //                         });
                        //                         if (tempArr2.toString() !== val2.resources.data.toString()) {
                        //                             //  获取不可删数组，并把数组转换成数组对象
                        //                             let _returnArr = [];
                        //                             let canNotDelArr = params.row.notModifyHandlerIds ? params.row.notModifyHandlerIds : [];
                        //                             canNotDelArr.map(innerItem => {
                        //                                 let _handlerIds = params.row.handlerIds.split(';').filter(item => item);
                        //                                 let _handlerNames = params.row.handlerNames.split(';').filter(item => item);
                        //                                 let _index = _handlerIds.indexOf(innerItem)
                        //                                 _returnArr.push({
                        //                                     user: innerItem,
                        //                                     userName: _handlerNames[_index],
                        //                                 });
                        //                             });
                        //                             //  不可删数组 与已选数组 进行合并
                        //                             tempObj.tempApprovalList = [..._returnArr, ...tempObj.tempApprovalList];
                        //                             this.$set(this.block2.data, params.index, tempObj);
                        //                         }
                        //                     },
                        //                     ssFsblur: () => {
                        //                     },
                        //                 },
                        //             })
                        //         }
                        //         if (params.row.mustSelected) {
                        //             mustChosen = h('div', {
                        //                 style: {
                        //                     position: 'absolute',
                        //                     right: '6px',
                        //                     top: '0px',
                        //                     color: 'red',
                        //                 }
                        //             }, '*')
                        //         }
                        //
                        //         let renderApprovalPsn = [];
                        //         params.row.tempApprovalList.forEach(item => {
                        //             let canNotDelArr = params.row.notModifyHandlerIds ? params.row.notModifyHandlerIds : [];
                        //             let canDel = !canNotDelArr.includes(item.user)
                        //
                        //             renderApprovalPsn.push(h('Tag', {
                        //                 props: {
                        //                     key: item.user,
                        //                     name: item.userName,
                        //                     // key: item.loginId,
                        //                     // name: item.name,
                        //                     color: 'blue',
                        //                     closable: params.row.canSelected && canDel,
                        //                 },
                        //                 on: {
                        //                     'on-close': () => {
                        //                         let _index = params.row.tempApprovalList.findIndex(innerItem => innerItem.user === item.user);
                        //                         params.row.tempApprovalList.splice(_index, 1);
                        //                         this.block2.data[params.index] = params.row;
                        //                     }
                        //                 }
                        //             }, item.userName));
                        //         });
                        //
                        //         return h('div', {
                        //             style: {
                        //                 display: 'flex',
                        //                 flexFlow: 'row nowrap',
                        //                 justifyContent: 'space-between',
                        //                 alignItems: 'center',
                        //             },
                        //         }, [
                        //             h('div', {}, [renderApprovalPsn,]),
                        //             h('div', {style: {position: 'relative'}}, [chosenBtn, mustChosen]),
                        //         ]);
                        //     }
                        // },
                        {
                            title: this.$t('approval.Approver'),            /* '审批人', */
                            key: 'handlerNames',
                            // align: 'center',
                            // width: 110,
                            render: (h, params) => {
                                let chosenBtn = '';
                                let mustChosen = '';

                                let _source = [];
                                let canNotDelArr = [];
                                this.block2.data[params.index].tempApprovalList.map(item => {
                                    _source.push(item.selectedId ? item.selectedId : item.user);
                                });

                                let _handlerIds = this.block2.data[params.index].handlerIds.split(';');
                                let _handlerMipIds = this.block2.data[params.index].handlerMipIds.split(';');
                                let _notModifyHandlerIds = params.row.notModifyHandlerIds ? params.row.notModifyHandlerIds : [];
                                _notModifyHandlerIds.forEach(item => {
                                    let _index = _handlerIds.indexOf(item);
                                    canNotDelArr.push(_handlerMipIds[_index]);
                                });

                                chosenBtn = h('vue-midea-selector', {
                                    props: {
                                        expendAccountName: this.expendAccountName,  //  树形控件定位当前登录人部门及弹出人员选择器显示登录人所在部门所有人员，此属性是根据当前登录人的账号名称来查找，请传入当前登录人的帐号名称（在有parent属性的前提下，不需要传递expendAccountName属性）
                                        source: _source.join(';'), //  父组件传入id（字符串传入用;隔开，如u1;u2;u3）到选择框中，用于显示以及回选已选人员/部门(注.接口只支持id不要传其他进来)
                                        dataType: '3',  //  当前人员选择器搜索的数据类型，1：部门，2：人员，3：全部，默认为全部
                                        env: this.env,     //  传入imip/uat/sit/dev分别对应正式/uat/sit/dev环境数据，默认为正式环境
                                        disabled: !params.row.canSelected,    //  禁用，布尔值为真禁用为假不禁用，默认为假
                                        lang: JSON.parse(window.localStorage.getItem('user')) ? JSON.parse(window.localStorage.getItem('user')).fdLangType : 'zh-CN',   //  当前语言参数分别为'zh-CN'、'en-US'、'ja-JP'；默认中文
                                        configurations: false,   //  在只需要弹框的情况传入true隐藏input输入框,显示为一个按钮
                                        bandellist: canNotDelArr //  禁止删除人员数组
                                        // customEnv: 'http://localhost.midea.com:8080',  //  传入url，修改接口域名
                                    },
                                    on: {
                                        /* 三个参数第一个为当前选中人员信息，第二个为当前组件id（需要配合id使用），第三个个为判断是传值还是人为改变 (passval为传值) （editval为用户修改） */
                                        callback: (p1, p2, p3) => {
                                            if (p3 === 'editval') {
                                                // console.log('p1::::', p1)
                                                // let _tempData = JSON.parse(JSON.stringify(p1));
                                                // console.log('_tempData::::', _tempData)
                                                // setTimeout(() => {
                                                //     let _tempData1 = JSON.parse(JSON.stringify(p1));
                                                //     console.log('_tempData1::::', _tempData1)
                                                // }, 1000)
                                                // console.log('_tempData::::', _tempData)
                                                let tempObj = JSON.parse(JSON.stringify(this.block2.data[params.index]));
                                                let stuffs = [];
                                                stuffs = p1.map(innerItem => {
                                                    // console.log('innerItem::::', innerItem)
                                                    // console.log('innerItem.loginName::::', innerItem.loginName)
                                                    return {
                                                        user: innerItem.departmentNumber ? innerItem.departmentNumber : (innerItem.loginName ? innerItem.loginName : innerItem.fdUid),
                                                        userName: innerItem.name,
                                                        // departmentNumber: innerItem.departmentNumber,
                                                        type: innerItem.departmentNumber ? 'DEPARTMENT' : 'USER',
                                                        selectedId: innerItem.id
                                                    };
                                                });
                                                // console.log('stuffs::::', stuffs)
                                                tempObj.tempApprovalList = JSON.parse(JSON.stringify(stuffs));
                                                this.$set(this.block2.data, params.index, tempObj);
                                            }
                                        }
                                        // selectorname: (p1, p2, p3) => {
                                        //     console.log('@@@@@@@@@@@@@@@@:', p1, p2, p3)
                                        // },
                                    }
                                });
                                // }
                                if (params.row.mustSelected) {
                                    mustChosen = h('div', {
                                        style: {
                                            position: 'absolute',
                                            right: '6px',
                                            top: '0px',
                                            color: 'red'
                                        }
                                    }, '*');
                                }

                                return h('div', {
                                    style: {
                                        display: 'flex',
                                        flexFlow: 'row nowrap',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }
                                }, [
                                    h('div', {style: {position: 'relative', width: '100%'}}, [chosenBtn, mustChosen])
                                ]);
                            }
                        }
                    ]
                },
                block3: {
                    data: [],
                    columns: [
                        {
                            title: this.$t('common.sequence'),              /* '序号', */
                            key: '',
                            align: 'center',
                            width: 50,
                            type: 'index'
                        },
                        {
                            title: this.$t('approval.ApprovalNode'),         /* '审批节点', */
                            key: 'fdNodeId',
                            align: 'center',
                            width: 70
                        },
                        {
                            title: this.$t('approval.NodeName'),            /* '节点名称', */
                            key: 'fdNodeName',
                            align: 'center',
                            width: 110
                        },
                        {
                            title: this.$t('approval.Operator'),            /* '操作人', */
                            key: 'fdHandlerName',
                            align: 'center',
                            width: 150,
                            render: (h, params) => {
                                return h('span', {}, params.row.fdHandlerName + (params.row.fdHandlerId ? '（' + params.row.fdHandlerId + '）' : ''));
                            }
                        },
                        {
                            title: this.$t('common.operation'),             /* '操作', */
                            key: 'fdOperationName',
                            align: 'center',
                            // width: 110,     //  #53A1E5     #54B99D     #ED3323     #F9CC46
                            render: (h, params) => {
                                return h('div', {}, [
                                    h('div', {
                                        style: {
                                            display: 'inline-block',
                                            width: '10px',
                                            height: '10px',
                                            borderRadius: '50%',
                                            marginRight: '5px',
                                            backgroundColor: this.fdOperationTypeList[params.row.fdOperationType]
                                        }
                                    }),
                                    h('span', {}, params.row.fdOperationName)
                                ]);
                            }
                        },
                        {
                            title: this.$t('approval.Annex'),            /* '附件', */
                            key: 'fujian',
                            align: 'center',
                            // width: 110,
                            render: (h, params) => {
                                let tempFileList = [];
                                if (params.row.fileList) {
                                    params.row.fileList.forEach(item => {
                                        tempFileList.push(h('div', {}, [
                                            h('a', {
                                                attrs: {
                                                    href: '/srmpos/common/downloadFile?docId=' + item.docId
                                                }
                                            }, item.fileName)]));
                                    });
                                }
                                return h('div', {}, tempFileList);
                            }
                        },
                        {
                            title: this.$t('approval.Approvalcomments'),            /* '审批意见', */
                            key: 'fdAuditeInfo',
                            align: 'center',
                            render: (h, params) => {
                                if (params.row.fdAuditeInfo && /\n/.test(params.row.fdAuditeInfo)) {
                                    let str = params.row.fdAuditeInfo.replace(/\n/g, '_$');
                                    str = str.split('_$');
                                    return h('div', str.map(item => {
                                        return h('p', {
                                            style: {
                                                textAlign: 'left',
                                                lineHeight: '20px'
                                            }
                                        }, item);
                                    }));
                                } else {
                                    return h('span', {
                                        style: {
                                            textAlign: 'left'
                                        }
                                    }, params.row.fdAuditeInfo);
                                }
                            }
                            // width: 110,
                        },
                        {
                            title: this.$t('approval.Time'),                /* '时间', */
                            key: 'fdHandlerTime',
                            align: 'center',
                            width: 160,
                            render: (h, params) => {
                                return h('span', {}, params.row.fdHandlerTime ? formatDateTime(new Date(params.row.fdHandlerTime), 'yyyy-MM-dd HH:mm:ss') : '');
                            }
                        }
                    ]
                },
                uploadLoading: false,
                approval: false,
                approvalStatus: '',
                manualNodes: [],    //  分支节点
                toNodeId: '',
                businessId: null,
                businessKey: null,
                orgCode: null,
                orgType: null,
                businessShareding: null,
                radioDisabled: false,
                approveRoleList: [],    //  按钮权限列表
                roleObj: {},    //  当前权限对象
                BtnList: [],    //  显示按钮列表
                rejectList: [],
                personModal: {
                    show: false,
                    modalTitle: this.$t('approval.PersonnelSelector'),            /* '人员选择器', */
                    modalWidth: 800,
                    onOk: () => {
                        if (this.chosenFrom === 'btnModalForm') {
                            this.btnModalForm.handlePersonList = JSON.parse(JSON.stringify(this.personModal.data2));
                        } else if (this.chosenFrom === 'block2') {
                            let tempObj = JSON.parse(JSON.stringify(this.block2.data[this.block2.currTblIndex]));
                            tempObj.tempApprovalList = JSON.parse(JSON.stringify(this.personModal.data2));
                            this.$set(this.block2.data, this.block2.currTblIndex, tempObj);
                        }
                    },
                    searchIpt: '',
                    settings: {
                        pageSize: 10,
                        currentPage: 1,
                        showElevator: false,
                        showSizer: false,
                        total: null,
                        pageSizeOpts: [10, 20, 50, 100]
                    },
                    data: [],
                    columns: [
                        {
                            title: '',
                            type: 'selection',
                            key: 'vendorRange',
                            align: 'left',
                            width: 40
                        },
                        {
                            title: '',
                            key: 'userName',
                            align: 'left',
                            // width: 110,
                            render: (h, params) => {
                                return h('Row', {}, [
                                    h('Row', {}, [
                                        h('Col', {
                                            props: {span: 12},
                                            style: {color: '#1c2438'}
                                        }, params.row.userName + '<' + params.row.user + '>'),
                                        // h('Col', {props: {span: 12}, style: {color: '#80848f'}}, params.row.jobStr)]),
                                        h('Col', {props: {span: 12}, style: {color: '#80848f'}}, params.row.duty)]),
                                    h('Row', {style: {color: '#80848f'}}, params.row.department)
                                ]);
                            }
                        }
                    ],
                    data2: [],
                    columns2: [
                        {
                            title: '',
                            key: 'userName',
                            align: 'left',
                            // width: 110,
                            render: (h, params) => {
                                return h('Row', {
                                    props: {
                                        type: 'flex',
                                        align: 'middle',
                                        justify: 'space-between'
                                    }
                                }, [
                                    h('Col', {props: {span: 12}, style: {color: '#1c2438'}}, params.row.userName),
                                    h('Col', {}, [h('Button', {
                                        props: {
                                            type: 'text',
                                            icon: 'close'
                                        },
                                        on: {
                                            'click': () => {
                                                this.personModal.data2.splice(params.index, 1);
                                                let tempIndex = this.personModal.data.findIndex(item => item.user === params.row.user);
                                                if (tempIndex !== -1) {
                                                    this.$refs['searchPerTable']['objData'][tempIndex]['_isChecked'] = false;
                                                }
                                            }
                                        }
                                    })])
                                ]);
                            }
                        }
                    ],
                    loading: false
                },
                btnShowModal: {
                    show: false,
                    modalTitle: '',
                    modalWidth: 800,
                    operationType: '',  //  按钮类型
                    onOk: () => {
                        this.handleClick();
                    },
                    FileList: [],
                    deleteFile: (_index) => {
                        this.btnShowModal.FileList.splice(_index, 1);
                    }
                },
                btnModalForm: {
                    auditNote: '',  //  流程处理意见
                    rejectTo: null,     //  驳回到
                    returnCurr: true,   //  重新提交后直接返回本节点
                    handlePersonList: []   //  处理人列表
                },
                fdOperationTypeList: {  //  颜色对照列表
                    draft_submit: '#53A1E5', //  提交
                    handler_pass: '#54B99D', //  通过
                    handler_refuse: '#ED3323', //  驳回
                    pending_approval: '#F9CC46' //  待审批
                },
                recordTblData: [],
                errorInfo: '',
                showTbl: false,
                supplierInfo: {},
                processCreatedBy: '',   // 单据流程创建人
                mideaSelector: {
                    expendAccountName: '',  //  树形控件定位当前登录人部门及弹出人员选择器显示登录人所在部门所有人员，此属性是根据当前登录人的账号名称来查找，请传入当前登录人的帐号名称（在有parent属性的前提下，不需要传递expendAccountName属性）
                    source: '', //  父组件传入id（字符串传入用;隔开，如u1;u2;u3）到选择框中，用于显示以及回选已选人员/部门(注.接口只支持id不要传其他进来)
                    dataType: '3',  //  当前人员选择器搜索的数据类型，1：部门，2：人员，3：全部，默认为全部
                    env: '',     //  传入imip/uat/sit/dev分别对应正式/uat/sit/dev环境数据，默认为正式环境
                    disabled: false,    //  禁用，布尔值为真禁用为假不禁用，默认为假
                    lang: '',   //  当前语言参数分别为'zh-CN'、'en-US'、'ja-JP'；默认中文
                    configurations: false,   //  在只需要弹框的情况传入true隐藏input输入框,显示为一个按钮
                    bandellist: [], //  禁止删除人员数组
                    callback: (p1, p2, p3) => {
                        this.btnModalForm.handlePersonList = p1.map(item => {
                            return {
                                user: item.departmentNumber ? item.departmentNumber : (item.loginName ? item.loginName : item.fdUid),
                                userName: item.name,
                                type: item.departmentNumber ? 'DEPARTMENT' : 'USER',
                                selectedId: item.id
                            };
                        });
                    }
                }
                // staffSelector: {
                //     // 是否开启弹窗可拖拉
                //     windowDragable: false,
                //     // 是否允许拖拽
                //     canDrag: true,
                //     // 取消快速搜索栏
                //     noFastBar: false,
                //     // 是否禁止编辑
                //     banEdit: false,
                //     // 是否单选
                //     single: false,
                //     // 是否只有快速选择
                //     onlyFsearch: false,
                //     // v-model是否回传loginId
                //     loginId: false,
                //     //只读模式（人名，人名，人名。。。）
                //     readOnly: false,
                //     //小图标+按钮风格 noFastBar 设为true 才能生效
                //     buttonStyle: false,
                //     // select type ： 人员和部门之间切换 1:只搜部门，2:只搜人，3:人和部门
                //     udType: 3,
                //     // 自定义快速搜索栏的搜索占位符
                //     fsPlaceholder: undefined,
                //     // 不能删除列表,以id为唯一标识
                //     banDelList: [],
                //     // 双向绑定值
                //     ssValue: [],
                //     // 当需要组件外更新人员时使用
                //     ssData: [],
                //     // 当前语言
                //     cLang: JSON.parse(window.localStorage.getItem('user')).fdLangType,//this.$store.state.user.fdLangType,
                //     //按钮文字
                //     buttonText: '',
                //     change: (val) => {
                //         this.btnModalForm.handlePersonList = val.map(item => {
                //             return {user: item.loginId, userName: item.name}
                //         });
                //     },
                //     fsblur: () => {
                //
                //     }
                // },
            };
        },
        computed: {
            getApprovalFormChange() {
                let tempArr = [];
                for (let i = 0; i < this.manualNodes.length; i++) {
                    tempArr.push(this.approvalForm['manualRadio_' + i]);
                }
                return tempArr;
            },
            showAnchorComputed() {
                return this.showAnchor === undefined ? this.showApproval : this.showAnchor;
            }
        },
        watch: {
            getApprovalFormChange: function (nVal, oVal) {
                if (nVal.findIndex(item => item === '' || item === null) !== -1) {
                    this.showTbl = false;
                } else {
                    this.showTbl = true;
                }
            },
            showAnchorComputed(nVal) {
                if (nVal) {
                    this.$nextTick(() => {
                        let isMipForm = this.$route.query && Object.keys(this.$route.query).includes('mbpmFlowId');
                        let _value = isMipForm ? 140 : 250;
                        this.$refs['anchorNavigation'].$el.querySelector('.fixed-bottom').style.height = (window.innerHeight - _value) + 'px';
                        this.$refs.scroll_wrapper.addEventListener('scroll', (e) => {
                            this.backTop = e.target.scrollTop >= 400;
                        });
                    });
                }
            }
        },
        methods: {
            backToTop() {
                this.toTop(this.$refs.scroll_wrapper);
            },
            toTop(ele) {
                // ele.scrollTop = 0;
                let dy = ele.scrollTop / 4; // 每次更新scrollTop改变的大小
                if (ele.scrollTop > 0) {
                    ele.scrollTop -= Math.max(dy, 10);
                    setTimeout(() => {
                        this.toTop(ele, dy);
                    }, 30);
                }
            },
            uploadProgress: function (event, file, fileList) {
                this.uploadLoading = true;
            },
            uploadSuccess: function (response, file) {
                this.uploadLoading = false;
                // let tempObj = {
                //     fileId: response.data.docId,
                //     fileName: response.data.fileName,
                //     fileSize: file.size / 1024 / 1024 > 1 ? Number(file.size / 1024 / 1024).toFixed(1) + 'M' : Number(file.size / 1024).toFixed(1) + 'K',
                // };
                // this.block1.data.push(tempObj);
                this.FileList.push({
                    fileId: response.data.docId,
                    fileName: response.data.fileName
                });
                this.$Modal.success({
                    title: this.$t('common.warn'),
                    content: this.$t('approval.UploadSucceeded')         /* '上传成功' */
                });
            },
            uploadSuccess2: function (response, file) {
                this.uploadLoading = false;
                this.btnShowModal.FileList.push({
                    fileId: response.data.docId,
                    fileName: response.data.fileName
                });
                this.$Modal.success({
                    title: this.$t('common.warn'),
                    content: this.$t('approval.UploadSucceeded')           /* '上传成功' */
                });
            },
            beforeUpload: function (file) {
                if (file.size > 52428800) {
                    this.$Message.warning({
                        title: this.$t('common.warn'),
                        content: this.$t('approval.tips5')           /* '文件大小不能超过10M！' */
                    });
                    return false;
                }
            },
            /** 获取mip审批流程 */
            getProcessTableInfoAndManualNodes: function () {
                return new Promise(resolve => {
                    let url = '/mip/workFlow/getProcessTableInfoAndManualNodes';
                    let params = {
                        manualBranchToNodes: [],
                        businessId: this.businessId,
                        businessKey: this.businessKey,
                        // loginName: this.supplierInfo.loginName,
                        orgCode: this.orgCode,
                        orgType: this.orgType,
                        businessShareding: this.businessShareding
                    };
                    for (let i = 0; i < this.manualNodes.length; i++) {
                        params.manualBranchToNodes.push({
                            nodeId: this.manualNodes[i]['nodeId'],
                            toNodeId: this.approvalForm['manualRadio_' + i]
                        });
                    }
                    this.radioDisabled = true;
                    axios.post(url, params).then(res => {
                            this.radioDisabled = false;
                            let rep = res.data;
                            if (rep.success) {
                                if (rep.data.status === 0) {
                                    this.processInfo = rep.data.data.processInfoDto;
                                    if (rep.data.data.processInfoDto.error) {
                                        this.errorInfo = rep.data.data.processInfoDto.errorInfo;
                                    }

                                    this.nodeInstanceId = rep.data.data.processInfoDto.currNodes.length === 0 ? null : rep.data.data.processInfoDto.currNodes[0].nodeInstanceId;
                                    this.currNodes = rep.data.data.processInfoDto.currNodes;
                                    let processNodes = rep.data.data.processTableInfoAndManualNodesDto.processNodes;
                                    /* 获取节点信息 */
                                    this.$emit('getCurrNodes', processNodes);
                                    this.manualNodes = rep.data.data.processTableInfoAndManualNodesDto.manualNodes;
                                    for (let i = 0; i < this.manualNodes.length; i++) {
                                        this.approvalForm['manualRadio_' + i] = this.manualNodes[i]['chosenToNodeId'];
                                        this.ruleValidate['manualRadio_' + i] = [{
                                            required: true,
                                            message: this.$t('approval.tips6'),          /* '请选择分支', */
                                            trigger: 'change'
                                        }];
                                    }
                                    this.currProcess = null;
                                    this.block2.data = JSON.parse(JSON.stringify(processNodes));
                                    for (let i = 0; i < processNodes.length; i++) {
                                        if (processNodes[i]['currentNode']) {
                                            this.currProcess = i;
                                        }
                                        this.block2.data[i].tempApprovalList = [];
                                        // this.block2.data[i].tempCanNotDelList = [];
                                        let tempHandlerIds = this.block2.data[i].handlerIds.split(';').filter(item => item);
                                        let tempHandlerNames = this.block2.data[i].handlerNames.split(';').filter(item => item);
                                        // for (let j = 0; j < tempHandlerIds.length; j++) {
                                        //     this.block2.data[i].tempApprovalList.push({
                                        //         userName: tempHandlerNames[j],
                                        //         user: tempHandlerIds[j],
                                        //     })
                                        // }
                                        // this.block2.data[i].tempApprovalList = this.block2.data[i].handlers.map(innerItem => {
                                        //     return {
                                        //         userName: innerItem.name,
                                        //         user: innerItem.id,
                                        //         type: innerItem.type,
                                        //     }
                                        // })
                                    }
                                    this.block2.data.map(item => {
                                        item.handlers.map(innerItem => {
                                            item.tempApprovalList.push({
                                                userName: innerItem.name,
                                                user: innerItem.id,
                                                type: innerItem.type,
                                                selectedId: innerItem.selectedId
                                            });
                                        });
                                    });

                                    if (this.currProcess === null) {
                                        this.currProcess = this.block2.data.length;
                                    } else {
                                        this.currProcess++;
                                    }

                                    this.barData = [];
                                    this.block2.data.forEach(item => {
                                        let _subTitleTooltip = item.handlers.map(innerItem => innerItem.name + '(' + innerItem.id + ')');
                                        this.barData.push({
                                            subTitle: item.handlerNames,
                                            title: item.nodeId + '.' + item.nodeName,
                                            subTitleTooltip: _subTitleTooltip.join(';')
                                        });
                                    });

                                    this.iframeSrc = rep.data.data.flowchartUrl;      //  流程图
                                    this.$nextTick(() => {
                                        this.iframeHeight = this.$refs.myiframe.contentWindow.outerHeight + 'px';
                                    });

                                    this.processCreatedBy = rep.data.data.processTableInfoAndManualNodesDto.processNodes[0].handlerIds;
                                    resolve(true);
                                } else {
                                    resolve(false);
                                }
                            } else {
                                this.$Modal.error({
                                    title: this.$t('common.warn'),
                                    content: this.$t('common.error1')
                                });
                            }
                        }
                    ).catch(() => {
                        this.radioDisabled = false;
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: this.$t('common.error1')
                        });
                    });
                });
            },
            /** 分支切换 */
            changeRaido: function (val) {
                this.toNodeId = val;
                this.getProcessTableInfoAndManualNodes().then(res => {
                    if (!res) {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: this.$t('common.error1')
                        });
                    }
                });
            },
            /** 获取mip审批流程 */
            queryAvilableNodesAndOperation: function () {
                return new Promise(resolve => {
                    let url = '/mip/workFlow/queryAvilableNodesAndOperation';
                    let params = {
                        method: 'view',      // 编辑页面：edit   审批页面：view
                        businessId: this.businessId,
                        businessKey: this.businessKey,
                        businessShareding: this.businessShareding
                        // loginName: this.supplierInfo.loginName,
                    };
                    axios.post(url, params).then(res => {
                            let rep = res.data;
                            if (rep.success) {
                                this.approveRoleList = rep.data.data;
                                // this.approveRoleList = [...rep.data.data];
    
                                if (this.approveRoleList.length === 1) {
                                    this.topForm.approveRole = this.approveRoleList[0]['roleType'];
                                } else if (this.approveRoleList.length > 1) {
                                    this.topForm.approveRole = 'approve';
                                }
                                 if (this.autoChangeRole) {
                                    this.changeApproveRole();
                                }
                                resolve();
                            } else {
                                this.$Modal.error({
                                    title: this.$t('common.warn'),
                                    content: this.$t('common.error1')
                                });
                            }
                        }
                    ).catch(() => {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: this.$t('common.error1')
                        });
                    });
                });
            },
            /** 切换操作角色 */
            changeApproveRole: function () {
                this.roleObj = this.topForm.approveRole ? this.approveRoleList.find(item => item.roleType === this.topForm.approveRole) : {};
                this.BtnList = this.topForm.approveRole ? this.roleObj.operationList : [];
                let sortArrKey = ['draft_submit', 'handler_pass', 'handler_refuse', 'handler_commission', 'handler_communicate', 'draft_abandon'];
                this.BtnList = this.BtnList.sort((a, b) => sortArrKey.indexOf(a.operationType) - sortArrKey.indexOf(b.operationType));
                this.BtnList.map((item, index) => {
                    this.$set(this.loadingObj, 'loading' + index, false);
                });
            },
            /** 按钮点击前的操作 */
            beforeClick: function (_index) {
                //  校验
                if (this.BtnList[_index].operationType === 'handler_refuse') { // 驳回
                    this.getProcessRefuseNode();
                }
                if (this.manualNodes.length) {
                    this.$refs['approvalForm'].validate(valid => {
                        if (valid) {
                            let validateBlock2 = true;
                            let validateBlock2_2 = true;

                            if (this.BtnList[_index].operationType === 'draft_submit') {
                                validateBlock2_2 = false;
                                this.block2.data.forEach((item, _index2) => {
                                    (item.mustSelected && item.tempApprovalList.length === 0) ? validateBlock2 = false : '';
                                    (_index2 !== 0 && item.tempApprovalList.length > 0 && !item.tempApprovalList.some(innerItem => innerItem.user === JSON.parse(window.localStorage.getItem('user')).loginName) && item.tempApprovalList.some(innerItem => innerItem.user !== JSON.parse(window.localStorage.getItem('user')).loginName)) ? validateBlock2_2 = true : '';
                                });
                            }

                            if (!validateBlock2) {
                                this.$Message.warning({
                                    title: this.$t('common.warn'),
                                    content: this.$t('approval.tips7'),         /* '请选择审批人', */
                                    duration: 2.5
                                });
                            }

                            if (!validateBlock2_2) {
                                this.$Message.warning({
                                    title: this.$t('common.warn'),
                                    content: this.$t('approval.tips8'),             /* '审批人不能为同一人', */
                                    duration: 2.5
                                });
                            }

                            if (validateBlock2 && validateBlock2_2) {
                                this.btnModalForm.rejectTo = null;
                                this.btnModalForm.handlePersonList = [];
                                this.btnModalForm.returnCurr = true;
                                if (this.BtnList[_index]['operationType'] === 'handler_pass') { // 通过
                                    this.btnModalForm.auditNote = '同意';
                                } else if (this.BtnList[_index]['operationType'] === 'handler_refuse') { // 驳回
                                    this.btnModalForm.auditNote = '驳回';
                                } else {
                                    this.btnModalForm.auditNote = '';
                                }
                                this.btnCurrIndex = _index;
                                this.btnShowModal.modalTitle = this.BtnList[_index]['name'];
                                this.btnShowModal.operationType = this.BtnList[_index]['operationType'];
                                this.btnShowModal.FileList = [];
                                this.btnShowModal.show = true;
                            }
                        } else {
                            this.$Modal.warning({
                                content: this.$t('approval.tips6'),         /* '请选择分支', */
                                title: this.$t('common.warn'),
                                duration: 2.5
                            });
                        }
                    });
                } else {
                    let validateBlock2 = true;
                    let validateBlock2_2 = true;
                    if (this.BtnList[_index].operationType === 'draft_submit') {
                        this.$emit('handlerSubmit');
                        validateBlock2_2 = false;
                        this.block2.data.forEach((item, _index2) => {
                            (item.mustSelected && item.tempApprovalList.length === 0) ? validateBlock2 = false : '';
                            (_index2 !== 0 && item.tempApprovalList.length > 0 && !item.tempApprovalList.some(innerItem => innerItem.user === JSON.parse(window.localStorage.getItem('user')).loginName) && item.tempApprovalList.some(innerItem => innerItem.user !== JSON.parse(window.localStorage.getItem('user')).loginName)) ? validateBlock2_2 = true : '';
                        });

                        if (!this.block2.data.some(item => item.mustSelected)) {
                            validateBlock2_2 = true;
                        }
                    }

                    if (!validateBlock2) {
                        this.$Message.warning({
                            title: this.$t('common.warn'),
                            content: this.$t('approval.tips7')         /* '请选择审批人' */
                        });
                    }

                    if (!validateBlock2_2) {
                        this.$Message.warning({
                            title: this.$t('common.warn'),
                            content: this.$t('approval.tips8'),         /* '审批人不能为同一人', */
                            duration: 2.5
                        });
                    }

                    if (validateBlock2 && validateBlock2_2) {
                        this.btnModalForm.rejectTo = null;
                        this.btnModalForm.handlePersonList = [];
                        this.btnModalForm.returnCurr = true;
                        if (this.BtnList[_index]['operationType'] === 'handler_pass') { // 通过
                            this.btnModalForm.auditNote = '同意';
                        } else if (this.BtnList[_index]['operationType'] === 'handler_refuse') { // 驳回
                            this.btnModalForm.auditNote = '驳回';
                        } else {
                            this.btnModalForm.auditNote = '';
                        }
                        this.btnCurrIndex = _index;
                        this.btnShowModal.modalTitle = this.BtnList[_index]['name'];
                        this.btnShowModal.operationType = this.BtnList[_index]['operationType'];
                        this.btnShowModal.FileList = [];
                        this.btnShowModal.show = true;
                    }
                }
            },

            handleBeforeClick: function (_index) {
                if (this.deelSubmit) {
                    if (this.BtnList[_index].operationType === 'draft_submit' && !this.approval) {
                        this.$emit('handleDeelSubmit', () => {
                            this.beforeClick(_index);
                        });
                    } else {
                        this.beforeClick(_index);
                    }
                } else {
                    this.beforeClick(_index);
                }
            },
            /** 按钮点击 */
            handleClick: function () {
                return new Promise(resolve => {
                    let url = '/mip/workFlow/approveProcess';

                    let changeNodeHandler = [];
                    this.block2.data.forEach(item => {
                        let tempUserList = item.tempApprovalList.map(innerItem => innerItem.user);
                        let tempHandlers = item.tempApprovalList.map(innerItem => {
                            return {
                                type: innerItem.type ? innerItem.type : 'USER',
                                id: innerItem.user,
                                selectedId: innerItem.selectedId
                            };
                        });
                        changeNodeHandler.push({
                            nodeId: item.nodeId,
                            handlerIds: tempUserList.join(';'),
                            handlers: tempHandlers
                        });
                    });
                    console.log('this.btnModalForm.handlePersonList:', this.btnModalForm.handlePersonList);
                    let tempToOtherPersonsList = this.btnModalForm.handlePersonList.map(item => item.user);
                    if (this.btnShowModal.operationType === 'handler_commission' || this.btnShowModal.operationType === 'handler_communicate' || this.btnShowModal.operationType === 'handler_abandon' || this.btnShowModal.operationType === 'circulate') {
                        if (tempToOtherPersonsList.length === 0) {
                            this.$Message.warning({
                                title: this.$t('common.warn'),
                                content: this.$t('approval.tips9'),         /* '处理人不能为空', */
                                duration: 2.5
                            });
                            return;
                        }
                        // if (tempToOtherPersonsList.find(item => item === this.))
                    }

                    let manualBranchToNodes = [];
                    for (let i = 0; i < this.manualNodes.length; i++) {
                        manualBranchToNodes.push({
                            nodeId: this.manualNodes[i].nodeId,
                            toNodeId: this.approvalForm['manualRadio_' + i]
                        });
                    }

                    let fileList = this.btnShowModal.FileList.map(item => {
                        return {
                            docId: item.fileId,
                            fileName: item.fileName,
                            fileType01: this.recordTblData.length + 1
                        };
                    });
                    let params = {
                        businessId: this.businessId,
                        businessKey: this.businessKey,
                        processParam: {
                            taskId: this.BtnList[this.btnCurrIndex]['fdTaskId'],
                            activityType: this.BtnList[this.btnCurrIndex]['fdActivityType'],
                            operationType: this.BtnList[this.btnCurrIndex]['operationType'],
                            toOtherPersons: tempToOtherPersonsList.join(';'),
                            auditNote: this.btnModalForm.auditNote,
                            refusePassedToThisNode: this.btnModalForm.returnCurr,
                            jumpToNodeId: this.btnModalForm.rejectTo,   //  驳回到
                            // changeNodeHandler: changeNodeHandler,    //本参数作用如下：如果单独对某个流程实例 修改节点名称、节点流转类型【并审、会审、串行】 或 转换抄送节点等，就使用本参数。
                            manualBranchToNodes: manualBranchToNodes   //  起草人决定人工决策分支走向时，本参数就要用上
                        },
                        formParam: {
                            subject: this.processInfo.subject
                        },
                        fileList: fileList,  //  上传的文件
                        businessShareding: this.businessShareding
                    };
                    console.log('params::::::::', params);
                    (this.BtnList[this.btnCurrIndex]['operationType'] === 'draft' || this.BtnList[this.btnCurrIndex]['operationType'] === 'draft_submit') ? params.processParam.changeNodeHandler = changeNodeHandler : '';
                    this.loadingObj['loading' + this.btnCurrIndex] = true;
                    axios.post(url, params).then(res => {
                            this.loadingObj['loading' + this.btnCurrIndex] = false;
                            let rep = res.data;
                            if (rep.success) {
                                if (rep.data.status === 0) {
                                    if (this.BtnList[this.btnCurrIndex]['operationType'] === 'draft_submit') {
                                        this.$emit('afterProcessSubmit');
                                    }
                                    if (this.BtnList[this.btnCurrIndex]['operationType'] === 'draft_return') {
                                        this.$emit('afterProcessReturn');
                                    }
                                    this.$Modal.success({
                                        title: this.$t('common.warn'),
                                        content: rep.data.msg,
                                        onOk: () => {
                                            if (this.$route.query && Object.keys(this.$route.query).includes('mbpmFlowId')) {
                                                window.open('', '_self').close();
                                            } else {
                                                this.handleReturnBtn();
                                            }
                                        }
                                    });
                                    resolve();
                                } else {
                                    this.$Modal.error({
                                        title: this.$t('common.warn'),
                                        content: rep.data.msg
                                    });
                                }
                            } else {
                                this.$Modal.error({
                                    title: this.$t('common.warn'),
                                    content: this.$t('common.error1')
                                });
                            }
                        }
                    ).catch(() => {
                        this.loadingObj['loading' + this.btnCurrIndex] = false;
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: this.$t('common.error1')
                        });
                    });
                });
            },

            /** 获取流程状态 */
            getProcessStatus: function (id, key) {
                return new Promise(resolve => {
                    let url = '/mip/workFlow/getProcessStatus';
                    let params = {
                        businessId: this.businessId,
                        businessKey: this.businessKey,
                        // loginName: this.supplierInfo.loginName,
                        businessShareding: this.businessShareding
                    };
                    axios.post(url, params).then(res => {
                            let rep = res.data;
                            if (rep.success) {
                                this.approvalStatus = rep.data.data;
                                this.approval = !((rep.data.data.fdStatusCode === '10' || rep.data.data.fdStatusCode === '11'));
                                resolve();
                            } else {
                                this.$Modal.error({
                                    title: this.$t('common.warn'),
                                    content: this.$t('common.error1')
                                });
                            }
                        }
                    ).catch(() => {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: this.$t('common.error1')
                        });
                    });
                });
            },
            /** 获取流程基本信息 */
            getProcessInfo: function (id, key) {
                id ? this.businessId = id : '';
                key ? this.businessKey = key : '';
                return new Promise(resolve => {
                    let url = '/mip/workFlow/getProcessInfo';
                    let params = {
                        businessId: this.businessId,
                        businessKey: this.businessKey,
                        // loginName: this.supplierInfo.loginName,
                        businessShareding: this.businessShareding
                    };
                    axios.post(url, params).then(res => {
                            let rep = res.data;
                            if (rep.success) {
                                if (rep.data.status === 0) {
                                    this.processInfo = rep.data.data;
                                    this.nodeInstanceId = rep.data.data.currNodes.length === 0 ? null : rep.data.data.currNodes[0].nodeInstanceId;
                                    this.currNodes = rep.data.data.currNodes;
                                    resolve(true);
                                } else {
                                    resolve(false);
                                }
                            } else {
                                this.$Modal.error({
                                    title: this.$t('common.warn'),
                                    content: this.$t('common.error1')
                                });
                            }
                        }
                    ).catch(() => {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: this.$t('common.error1')
                        });
                    });
                });
            },
            clickInput: function () {
                this.personModal.settings.currentPage = 1;
                this.queryUser();
            },
            /** 获取mip用户信息 */
            queryUser: function () {
                return new Promise(resolve => {
                    let url = '/srmbase/user/queryUserByUserOrName';
                    let params = {
                        pageNum: this.personModal.settings.currentPage,
                        pageSize: this.personModal.settings.pageSize,
                        userName: this.personModal.searchIpt
                    };
                    this.personModal.loading = true;
                    axios.post(url, params).then(res => {
                            this.personModal.loading = false;
                            if (res.success) {
                                this.personModal.data = res.data.data.list;
                                this.personModal.settings.total = res.data.data.total;
                                this.personModal.data.map(item => {
                                    if (this.personModal.data2.find(innerItem => item.user === innerItem.user)) {
                                        item['_checked'] = true;
                                    }
                                });
                            } else {
                                this.$Modal.error({
                                    title: this.$t('common.warn'),
                                    content: this.$t('common.error1')
                                });
                            }
                        }
                    ).catch(() => {
                        this.personModal.loading = false;
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: this.$t('common.error1')
                        });
                    });
                });
            },
            /** 人员选择框勾选变化 */
            onSelectionChange: function (selection) {
                let selectedData = this.$refs.searchPerTable.getSelection();    //  左边已勾选数据
                let unSelectedData = [];    //  左边未勾选数据
                this.personModal.data.forEach(item => {
                    let index = selectedData.findIndex(itemInnder => itemInnder.user === item.user);
                    if (index === -1) {
                        unSelectedData.push(item);
                    }
                });

                //  假如左边勾选的数据右边没有，则添加到右边
                selectedData.forEach(item => {
                    let tempObj = this.personModal.data2.find(innerItem => innerItem.user === item.user);
                    if (!tempObj) {
                        this.personModal.data2.push(item);
                    }
                });
                //  假如左边未勾选的数据右边有，则右边删除
                unSelectedData.forEach(item => {
                    let tempIndex = this.personModal.data2.findIndex(innerItem => innerItem.user === item.user);
                    if (tempIndex !== -1) {
                        this.personModal.data2.splice(tempIndex, 1);
                    }
                });
        },
            onPageSizeChangeModal: function (currentPage, pageSize, condition) {
                this.personModal.settings.pageSize = pageSize;
                this.queryUser();
            },
            onCurrentPageChangeModal: function (currentPage, pageSize, condition) {
                this.personModal.settings.currentPage = currentPage;
                this.queryUser();
            },
            /** 删除全部 */
            delAll: function () {
                this.personModal.data2 = [];
                for (let i = 0; i < this.personModal.data.length; i++) {
                    this.$refs['searchPerTable']['objData'][i]['_isChecked'] = false;
                }
            },
            /** 添加全部 */
            selectAll: function () {
                for (let i = 0; i < this.personModal.data.length; i++) {
                    this.$refs['searchPerTable']['objData'][i]['_isChecked'] = true;
                }
                this.personModal.data.forEach(item => {
                    let tempIndex = this.personModal.data2.findIndex(innerItem => innerItem.user === item.user);
                    if (tempIndex === -1) {
                        this.personModal.data2.push(item);
                    }
                });
            },
            /** 获取已提交的审批流程 */
            getFlowLog: function () {
                return new Promise(resolve => {
                    let url = '/mip/workFlow/getFlowLog';
                    let params = {
                        businessId: this.businessId,
                        businessKey: this.businessKey,
                        // loginName: this.supplierInfo.loginName,
                        businessShareding: this.businessShareding
                    };
                    axios.post(url, params).then(res => {
                            let rep = res.data;
                            if (rep.success) {
                                this.block3.data = rep.data.data;
                                resolve();
                            } else {
                                this.$Modal.error({
                                    title: this.$t('common.warn'),
                                    content: this.$t('common.error1')
                                });
                            }
                        }
                    ).catch(() => {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: this.$t('common.error1')
                        });
                    });
                });
            },
            /** 获取已提交的审批流程 */
            getAuditeNote: function () {
                return new Promise(resolve => {
                    let url = '/mip/workFlow/getAuditeNote';
                    let params = {
                        businessId: this.businessId,
                        businessKey: this.businessKey,
                        // loginName: this.supplierInfo.loginName,
                        businessShareding: this.businessShareding
                    };
                    axios.post(url, params).then(res => {
                            let rep = res.data;
                            if (rep.success) {     //  fdNodeId,fdNodeName,fdHandlerName,fdOperationName
                                this.recordTblData = rep.data.data;
                                this.currNodes.map(item => {
                                    item.fdNodeName = JSON.parse(JSON.stringify(item.nodeName));
                                    item.fdNodeId = JSON.parse(JSON.stringify(item.nodeId));
                                    item.fdHandlerName = item.handlers.map(innerItem => {
                                        return innerItem.name + '(' + innerItem.id + ')';
                                    }).join(';');
                                    item.fdOperationName = this.$t('approval.PendingApproval');       /* '待审批'; */
                                    item.fdOperationType = 'pending_approval';
                                });
                                this.block3.data = [...rep.data.data, ...this.currNodes];
                                if (this.block3.data.length) {
                                    let draftList = this.block3.data.filter(item => item.fdNodeId === 'N1');
                                    if (draftList && draftList.length) {
                                        this.draftInfo = JSON.parse(JSON.stringify(draftList[0]));
                                        this.draftInfo.fdHandlerTime = this.draftInfo.fdHandlerTime ? formatDateTime(new Date(this.draftInfo.fdHandlerTime), 'yyyy-MM-dd') : '';
                                        console.log('draftInfo', this.draftInfo);
                                    }
                                }
                                resolve();
                            } else {
                                this.$Modal.error({
                                    title: this.$t('common.warn'),
                                    content: this.$t('common.error1')
                                });
                            }
                        }
                    ).catch(() => {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: this.$t('common.error1')
                        });
                    });
                });
            },
            /** 删除上传文件 */
            deleteFile: function (_index) {
                this.FileList.splice(_index, 1);
            },
            /** 弹出框选择处理人 */
            handleAddPerson: function () {
                this.chosenFrom = 'btnModalForm';
                this.resetPersonModal(this.btnModalForm.handlePersonList);
                this.personModal.show = true;
            },
            handleClosePerson: function (event, name) {
                let _index = this.btnModalForm.handlePersonList.findIndex(item => item.userName === name);
                this.btnModalForm.handlePersonList.splice(_index, 1);
            },
            /** 清空弹出框数据,并重设数据 */
            resetPersonModal: function (arr) {
                this.personModal.data = [];
                this.personModal.data2 = JSON.parse(JSON.stringify(arr));
            },
            /** 获取可驳回节点 */
            getProcessRefuseNode: function () {
                return new Promise(resolve => {
                    let url = '/mip/workFlow/getProcessRefuseNode';
                    let params = {
                        businessId: this.businessId,
                        businessKey: this.businessKey,
                        // loginName: this.supplierInfo.loginName,
                        nodeInstanceId: this.nodeInstanceId,
                        businessShareding: this.businessShareding
                    };
                    axios.post(url, params).then(res => {
                            let rep = res.data;
                            if (rep.success) {
                                if (rep.data.status === 0) {
                                    this.rejectList = rep.data.data;
                                    resolve();
                                } else {
                                }
                            } else {
                                this.$Modal.error({
                                    title: this.$t('common.warn'),
                                    content: this.$t('common.error1')
                                });
                            }
                        }
                    ).catch(() => {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: this.$t('common.error1')
                        });
                    });
                });
            },
            /** 返回按钮 */
            returnBtn: function () {
                this.handleReturnBtn();
            },
            handleReturnBtn() {
                console.log('selfFrom:::', this.$selfFrom);
                console.log('urlQuery:::', this.$route);
                if (this.$selfFrom && this.$selfFrom.path === '/toDo/toDo') {
                    this.$store.dispatch('closeTag', this.$route);
                    setTimeout(() => {
                        this.$router.push('/toDo/toDo');
                    }, 0);
                } else if (this.$route.query && Object.keys(this.$route.query).includes('mbpmFlowId')) {
                    window.open('', '_self').close();
                } else {
                    this.$emit('handleReturnBtn');
                }
            },
            searchInfo: async function (id, key, orgCode, orgType, businessShareding) {
                id ? this.businessId = id : '';
                key ? this.businessKey = key : '';
                orgCode ? this.orgCode = orgCode : '';
                orgType ? this.orgType = orgType : '';
                businessShareding ? this.businessShareding = businessShareding : '';

                let _result = await this.getProcessTableInfoAndManualNodes();
                if (_result) {
                    this.getProcessStatus();
                    // this.getProcessRefuseNode();
                    // this.getProcessTableInfoAndManualNodes();
                    await this.queryAvilableNodesAndOperation();
                    await this.getAuditeNote();
                }
                // this.getAuditeNoteInAllNodes();
            },
            refreshIframe: function (name) {
                if (name === 'childTab2') {
                    let tempSrc = Object.assign(this.iframeSrc);
                    this.iframeSrc = '';
                    this.$nextTick(() => {
                        this.iframeSrc = tempSrc;
                        this.iframeHeight = this.$refs.myiframe.contentWindow.outerHeight + 'px';
                    });
                    // window.open(tempSrc);
                }
            },
            iframeLoaded: function () {
                // this.iframeSrc = '';
            },
            /** 取上次审批处理人 **/
            getPrevProcessApprovers: function () {
                return new Promise(resolve => {
                    let url = '/mip/workFlow/getPrevProcessApprovers';
                    let params = {
                        businessId: this.businessId,
                        businessKey: this.businessKey,
                        businessShareding: this.businessShareding
                    };
                    axios.post(url, params).then(res => {
                            let rep = res.data;
                            if (rep.success) {
                                if (rep.data.status === 0) {
                                    rep.data.data.nodeHandlersList.map(item => {
                                        this.block2.data.map((innerItem, _innerIndex) => {
                                            if (innerItem.nodeId === item.nodeId) {
                                                let tempIdArr = item.handlerIds.split(';');
                                                let tempNameArr = item.handlerNames.split(';');
                                                innerItem.tempApprovalList = tempIdArr.map((stuffItem, stuffIndex) => {
                                                    return {
                                                        userName: tempNameArr[stuffIndex],
                                                        user: tempIdArr[stuffIndex]
                                                    };
                                                });
                                                this.$set(this.block2.data, _innerIndex, innerItem);
                                            }
                                        });
                                });
                                    resolve();
                                } else {
                                    this.$Modal.error({
                                        title: this.$t('common.warn'),
                                        content: rep.data.msg
                                    });
                                }
                            } else {
                                this.$Modal.error({
                                    title: this.$t('common.warn'),
                                    content: rep.msg
                                });
                            }
                        }
                    ).catch(() => {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: this.$t('common.error1')
                        });
                    });
                });
            }
        },
        created() {
            this.mideaSelector.env = location.hostname === 'gsc.midea.com' ? 'imip' : 'uat';
            this.mideaSelector.lang = JSON.parse(window.localStorage.getItem('user')).fdLangType || 'zh-CN';
        },
        mounted() {
            this.supplierInfo = JSON.parse(window.localStorage.getItem('user')) || {};
            this.expendAccountName = this.supplierInfo.loginName;
        }
    };
</script>
<style lang="less" scoped>
    .approval {
        background: #f5f7f9;
        .fixed-bottom{
            overflow-y: auto;
            /*margin-top: 100px;*/
        }
        .mainHeader {
            display: inline-block;
            color: #464c5b;
            font-size: 16px;
            font-weight: bold;
        }

        .no-mb {
            /deep/ .m-form-item {
                margin-bottom: 0;
            }
        }

        .set-flex {
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;
        }

        .status {
            display: inline-block;
            margin-left: 20px;
            /*background-color: #DCF6F7;*/
            background: rgba(49, 139, 245, 0.1);
            color: #1d78f4;
            width: 60px;
            height: 22px;
            line-height: 22px;
            text-align: center;
            border-radius: 5%;
            font-size: 12px;
        }

        .subheading {
            font-size: 14px;
            font-weight: bold;
            color: #464c5b;
        }

        .auxiliary {
            font-size: 12px;
            color: #9ea7b4;
        }

        .mb-10 {
            margin-bottom: 10px;
        }

        .mt-20 {
            margin-top: 20px;
        }

        .mt-15 {
            margin-top: 15px
        }

        .mb-20 {
            margin-bottom: 20px;
        }

        /deep/ .assembly-cls .pd-l-r-20 {
            padding: 0;
        }

        /deep/ .assembly-cls .set-pd {
            padding: 0;
        }

        /deep/ .assembly-cls .bottom-line {
            border-bottom: 0px solid #F2F2F2;
        }

        /deep/ .set-h-20 {
            height: 4px;
        }

        .operate-box {
            margin-top: 10px;
            display: flex;
        }
        
        .operate-box .operate-btn {
            margin-left: 10px;
        }
        .operate-box .operate-btn:first-of-type{
            margin-left: 0;
        }

        .operate-info {
            text-align: right;
            color:#999;
            font-size: 12px;
            p {
                line-height: 24px;
            }
        }
        /*/deep/ .mss-icon .mss-icon-user {*/
        /*color: #3aa2eb !important;*/
        /*}*/
    }
</style>
<style lang="less">
    .m-tooltip-inner {
        max-width: 800px;
    }

    .appt-pooers {
        right: 8px;
    }
    /*.MideaSelectors {*/
    /*.selector-content {*/
    /*font-size: 12px;*/
    /*}*/
    /*}*/

</style>
